export const deposit = {
  en: {
    "wallet.deposit.deposit_method": "Deposit method",
    "wallet.deposit.payment_details": "Payment details",
    "wallet.deposit.payment_process": "Payment process",
    "wallet.deposit.payment_execution": "Payment execution",
    "wallet.deposit.min": "Min",
    "wallet.deposit.time": "min",

    "wallet.deposit.back": "Back",
    "wallet.deposit.payment_method": "Payment Method",
    "wallet.deposit.commission": "Commission",
    "wallet.deposit.minimum_deposit_amount": "Minimum deposit amount",
    "wallet.deposit.processing_time": "Processing time",
    "wallet.deposit.amount": "Amount",
    "wallet.deposit.network": "Network",
    "wallet.deposit.network_confirmation":
      "Funds are received after network confirmation",
    "wallet.deposit.you_receive": "You Receive",
    "wallet.deposit.continue_and_pay": "Continue and pay",
    "wallet.deposit.need_help": "Need help?",
    "wallet.deposit.help_text":
      "If you have any questions or need assistance, our support team is here to help.",
    "wallet.deposit.contact_support": "Contact Support Service",

    "wallet.withdrawal.amount_exceeds_balance":
      "Amount exceeds available balance",
  },

  ru: {
    "wallet.deposit.deposit_method": "Метод оплаты",
    "wallet.deposit.payment_details": "Детали платежа",
    "wallet.deposit.payment_process": "Процесс оплаты",
    "wallet.deposit.payment_execution": "Завершение платежа",
    "wallet.deposit.min": "Мин",
    "wallet.deposit.time": "мин",

    "wallet.deposit.back": "Назад",
    "wallet.deposit.payment_method": "Способ оплаты",
    "wallet.deposit.commission": "Комиссия",
    "wallet.deposit.minimum_deposit_amount": "Минимальная сумма депозита",
    "wallet.deposit.processing_time": "Время обработки",
    "wallet.deposit.amount": "Сумма",
    "wallet.deposit.network": "Сеть",
    "wallet.deposit.network_confirmation":
      "Средства поступят после подтверждения сети",
    "wallet.deposit.you_receive": "Вы получите",
    "wallet.deposit.continue_and_pay": "Продолжить и оплатить",
    "wallet.deposit.need_help": "Нужна помощь?",
    "wallet.deposit.help_text":
      "Если у вас есть вопросы или нужна помощь, наша служба поддержки всегда готова помочь.",
    "wallet.deposit.contact_support": "Связаться со службой поддержки",

    "wallet.withdrawal.amount_exceeds_balance":
      "Сумма превышает доступный баланс",
  },

  es: {
    "wallet.deposit.deposit_method": "Método de depósito",
    "wallet.deposit.payment_details": "Detalles del pago",
    "wallet.deposit.payment_process": "Proceso de pago",
    "wallet.deposit.payment_execution": "Ejecución del pago",
    "wallet.deposit.min": "Mín",
    "wallet.deposit.time": "min",

    "wallet.deposit.back": "Volver",
    "wallet.deposit.payment_method": "Método de pago",
    "wallet.deposit.commission": "Comisión",
    "wallet.deposit.minimum_deposit_amount": "Importe mínimo de depósito",
    "wallet.deposit.processing_time": "Tiempo de procesamiento",
    "wallet.deposit.amount": "Cantidad",
    "wallet.deposit.network": "Red",
    "wallet.deposit.network_confirmation":
      "Los fondos se reciben después de la confirmación de la red",
    "wallet.deposit.you_receive": "Recibirás",
    "wallet.deposit.continue_and_pay": "Continuar y pagar",
    "wallet.deposit.need_help": "¿Necesitas ayuda?",
    "wallet.deposit.help_text":
      "Si tienes alguna pregunta o necesitas ayuda, nuestro equipo de soporte está aquí para ayudarte.",
    "wallet.deposit.contact_support": "Contactar con soporte",

    "wallet.withdrawal.amount_exceeds_balance":
      "La cantidad excede el saldo disponible",
  },

  ua: {
    "wallet.deposit.deposit_method": "Метод поповнення",
    "wallet.deposit.payment_details": "Платіжні реквізити",
    "wallet.deposit.payment_process": "Процес оплати",
    "wallet.deposit.payment_execution": "Здійснення платежу",
    "wallet.deposit.min": "Мін",
    "wallet.deposit.time": "хв",

    "wallet.deposit.back": "Назад",
    "wallet.deposit.payment_method": "Спосіб оплати",
    "wallet.deposit.commission": "Комісія",
    "wallet.deposit.minimum_deposit_amount": "Мінімальна сума депозиту",
    "wallet.deposit.processing_time": "Час обробки",
    "wallet.deposit.amount": "Сума",
    "wallet.deposit.network": "Мережа",
    "wallet.deposit.network_confirmation":
      "Кошти надходять після підтвердження мережею",
    "wallet.deposit.you_receive": "Ви отримуєте",
    "wallet.deposit.continue_and_pay": "Продовжити та оплатити",
    "wallet.deposit.need_help": "Потрібна допомога?",
    "wallet.deposit.help_text":
      "Якщо у вас виникли запитання або потрібна допомога, наша служба підтримки завжди готова допомогти.",
    "wallet.deposit.contact_support": "Зв'язатися зі службою підтримки",

    "wallet.withdrawal.amount_exceeds_balance":
      "Сума перевищує доступний баланс",
  },
};

export default deposit;
